import categoryService from "../../../services/ticketService/categoryService";
import { useQuery } from "@tanstack/react-query";
import { CategoryInterface } from "../../../models/TicketModule/Category";
import { CACHE_KEY_CATEGORIES } from "../../../utils/constants";

const useCategoryById = (id: string) =>
  useQuery<CategoryInterface, Error>({
    queryKey: [`${CACHE_KEY_CATEGORIES}ById`, id],
    queryFn: ({ queryKey }) => {
      const [, statusId] = queryKey;
      return categoryService.GetById(statusId as string);
    },
    enabled: !!id,
  });

export default useCategoryById;
